// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bOWdEGsspjglUq5Q{margin-left:48px}.bOWdEGsspjglUq5Q .hWzu3V8aHx455IH_{margin:0 auto;max-width:1108px}.ZTfNTr5kVekVj5LX{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminSection": `bOWdEGsspjglUq5Q`,
	"content": `hWzu3V8aHx455IH_`,
	"adminTitle": `ZTfNTr5kVekVj5LX`
};
export default ___CSS_LOADER_EXPORT___;
